export default __webpack_public_path__ + "02cc2e03474786dbace676f88d986c7b.jpg";